import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CatUploadService } from 'src/app/services/cat-upload.service';
import { LoaderService } from 'src/app/services/loader.service';
import { Location } from '@angular/common';
import { StorageService } from 'src/app/services/storage.service';
import { OrderService } from 'src/app/services/order.service';
import { Subscription } from 'rxjs';
import { AnalyticsService } from 'src/app/services/analytics.service';

@Component({
    selector: 'app-order-confirmation-details',
    templateUrl: './order-confirmation-details.component.html',
    styleUrls: ['./order-confirmation-details.component.scss'],
    standalone: false
})
export class OrderConfirmationDetailsComponent implements OnInit, OnDestroy {
  @Input() orderConfirmationData: any = [];
  @Output() orderConfirmationChange: EventEmitter<any> = new EventEmitter<[]>();
  states: any;
  events: any;
  selectedState: any;
  currentDate = new Date();
  email: string = 'yourMail@gmail.com';
  orderDetails: any = { id: '001', service: 'Service', date: 'DD/MM/YYYY' };
  formattedDate: string;
  orderPlaced: boolean = false;
  placedOrderDetails: any;
  active_product: boolean = true;
  active_sign: boolean = true;
  active_confirm: boolean = true;
  showUploadDocuments: boolean = false;
  showSignDetails: boolean = false;
  showConfirmation: boolean = true;
  showTab: boolean = false;
  isBulk: boolean = false;
  userRole: string;
  orderDetailsData: any = [];
  serviceType: string = '';
  eStampData: any = [];
  orderReviewer: any = [];
  eSignData: any = [];
  showEsignTab: boolean = false;
  showCatUpload: boolean = false;
  showCatEdit: boolean = false;
  showCatCompose: boolean = false;
  setheader: boolean = false;
  showCatImport: boolean;
  isCatImport: boolean;
  private subscription: Subscription;
  showBulkEstamp: boolean = false;
  orderIds: (string | number)[] = [];
  constructor(
    private router: Router,
    private orderService: OrderService,
    private activatedRouter: ActivatedRoute,
    private catUploadService: CatUploadService,
    private _location: Location,
    private loader: LoaderService,
    private storageService: StorageService,
    private analytics: AnalyticsService,
    private cdr: ChangeDetectorRef
  ) {
    setTimeout(() => {
      this.orderPlaced = true;
    }, 2000);
    this.activatedRouter.queryParams.subscribe((queryParams) => {
      if (queryParams['type'] === 'bulk_estamp') {
        this.showBulkEstamp = true;
        this.showTab = false;
      }
    });
    this.activatedRouter.params.subscribe((params) => {
      const orderId = params['id'];
      const currentUrl = this.router.url;

      if (currentUrl.includes('/cat-edit/order-confirmation/bulk/')) {
        this.getOrderConfirmation(orderId);
        this.showCatEdit = true;
        this.isBulk = true;
      } else if (currentUrl.includes('/cat-edit/order-confirmation/')) {
        this.OrderDetails(orderId);
        this.showCatEdit = true;
      } else if (currentUrl.includes('/e-stamp/order-confirmation/bulk')) {
        this.getOrderConfirmation(orderId);
        this.showTab = true;
        this.setheader = true;
      } else if (currentUrl.includes('/e-stamp/order-confirmation/')) {
        this.OrderDetails(orderId);
        this.showTab = true;
      } else if (currentUrl.includes('/e-sign/order-confirmation/')) {
        this.OrderDetails(orderId);
        this.showEsignTab = true;
      } else if (currentUrl.includes('/cat-execution/order-confirmation/')) {
        this.OrderDetails(orderId);
        this.showCatUpload = true;
      } else if (currentUrl.includes('/cat-compose/order-confirmation/')) {
        this.OrderDetails(orderId);
        this.showCatCompose = true;
      } else if (currentUrl.includes('/cat-import/order-confirmation/')) {
        this.OrderDetails(orderId);
      } else {
        if (orderId) {
          if (this.showBulkEstamp) {
            this.getBulkOrderConfirmation(orderId);
          } else {
            this.showTab = true;
            this.getOrderConfirmation(orderId);
          }
        } else {
          this.getPlacedOrderDetails();
        }
      }
    });

    this.formattedDate = `${this.currentDate.getDate()} ${this.currentDate.toLocaleString('en-US', { month: 'short' })} ${this.currentDate.getFullYear()} | ${this.formatHours(this.currentDate.getHours())}:${this.formatMinutes(this.currentDate.getMinutes())} ${this.currentDate.getHours() >= 12 ? 'pm' : 'am'}`;
    this.events = [
      { status: 'Order Placed', date: this.formattedDate, color: 'status_int' },
      {
        status: 'Order Initiated',
        date: this.formattedDate,
        color: 'status_progress'
      },
      {
        status: 'Order Completed',
        date: 'Estimated delivery, 5 Jul 2023',
        color: 'status_delvered'
      }
    ];

    this.userRole = this.storageService.getRole() || null;
  }

  ngOnInit(): void {
    window.addEventListener('popstate', (event: PopStateEvent) => {
      this.userRole === 'CLIENT'
        ? (window.location.href = '/doqfy/dashboard')
        : (window.location.href = '/doqfy/admin-dashboard');
    });
    this.subscription = this.catUploadService.orderIds$.subscribe((ids) => {
      this.orderIds = ids;
      this.cdr.detectChanges();
    });
  }
  gotoDashboard() {
    this.router.navigate(['doqfy/dashboard']);
  }
  getBulkOrderConfirmation(orderId: string): void {
    this.orderService
      .getBulkCatUploadOrders({ bulk_order_uuid: orderId })
      .subscribe((resp) => {
        if (resp?.data?.length) {
          this.placedOrderDetails = resp.data[0];
          this.isBulk = true;
        }
        this.cdr.detectChanges();
      });
  }

  getPlacedOrderDetails() {
    setTimeout(() => {
      this.loader.hide();
      this.placedOrderDetails = this.catUploadService.orderDetails;

      if (
        this.placedOrderDetails.status === 'WAITING_FOR_APPROVAL' ||
        this.placedOrderDetails.status_display === 'WAITING_FOR_APPROVAL'
      ) {
        this.placedOrderDetails.status_display = 'Approval Pending';
      }

      if (this.placedOrderDetails.is_bulk) {
        this.isBulk = true;
        this.orderService.orderType = 'Bulk';
        this.cdr.detectChanges();
      } else {
        this.OrderDetails(this.placedOrderDetails.id);
        this.isBulk = false;
        this.orderService.orderType = 'Individual';
      }
    }, 1000);
  }

  //----------------Cat Edit Bulk order --------------------------------//

  getOrderConfirmation(orderId) {
    let reqParams = {
      bulk_order_id: orderId.toString(),
      detail: 1
    };
    this.catUploadService.getBulkOrders(reqParams).subscribe((res: any) => {
      if (res.status === 200) {
        this.isBulk = true;
        this.placedOrderDetails = res.content[0];

        if (
          this.placedOrderDetails.status === 'WAITING_FOR_APPROVAL' ||
          this.placedOrderDetails.status_display === 'WAITING_FOR_APPROVAL'
        ) {
          this.placedOrderDetails.status_display = 'Approval Pending';
        }
      }
      this.cdr.detectChanges();
    });
  }

  //-----------------------------------------------------------------------//

  formatHours(hours: number) {
    return hours % 12 || 12;
  }

  formatMinutes(minutes: { toString: () => string }) {
    return minutes.toString().padStart(2, '0');
  }

  goToOrdersPage(order) {
  if (!order) return;
  var status = '';
  var serviceType = '';

  switch (order.status_display) {
    case 'Initiated':
      status = 'INITIATED';
      break;
    case 'Waiting for Approval':
      status = 'WAITING_FOR_APPROVAL';
      break;
    case 'Approval Pending':
      status = 'WAITING_FOR_APPROVAL';
      break;
    case 'Wating For Stamp':
      status = 'WAITING_FOR_STAMP';
      break;
    case 'In Progress':
      status = 'IN_PROGRESS';
      break;
    case 'Completed':
      status = 'COMPLETED';
      break;
    case 'Wating For Payment':
      status = 'WAITING_FOR_PAYMENT';
  }
  switch (order.order_type_display) {
    case 'Estamp':
      serviceType = 'ESTAMP';
      break;
    case 'Esign':
      serviceType = 'ESIGN';
      break;
    case 'Cat Upload':
      serviceType = 'CAT_UPLOAD';
      break;
    case 'Cat Edit':
      serviceType = 'CAT_EDIT';
      break;
  }

  if (this.showBulkEstamp) {
    this.router.navigate(['/doqfy/orders/orders-list'], {
      queryParams: {
        tabIndex: 2
      }
    });
    return;
  }

  this.router.navigate(['/doqfy/orders/orders-list'], {
    queryParams: {
      serviceType: serviceType,
      orderStatus: status,
      branch: order.branch,
      createdOn: order.created,
      id: order.id,
      isBulk: this.isBulk
    }
  });
}
  OrderDetails(id) {
    const data = { order_ids: id, detail: 1 };
    this.catUploadService.getOrderConfirmation(data).subscribe((res) => {
      this.placedOrderDetails = res['content'][0].order;
      this.orderService.logOrderTransaction(
        this.placedOrderDetails.id, 
        this.placedOrderDetails.order_type_display
      );
      if (this.placedOrderDetails.status === 'WAITING_FOR_APPROVAL') {
        this.placedOrderDetails.status_display = 'Approval Pending';
      }
      if (this.placedOrderDetails.order_type === 'IMPORT_CONTRACT') {
        this.showCatImport = true;
      }
      this.orderDetailsData = res['content'][0];
      this.eStampData = this.orderDetailsData.estamp;
      this.eSignData = this.orderDetailsData.esign;
      this.orderReviewer = this.orderDetailsData.order_reviewers;

      this.orderDetailsData.bulk_order
        ? (this.orderService.orderType = 'Bulk')
        : (this.orderService.orderType = 'Individual');
      this.cdr.detectChanges();
    });
  }

  back() {
    this.userRole === 'CLIENT'
      ? this.router.navigate(['doqfy/dashboard'])
      : this.router.navigate(['doqfy/admin-dashboard']);
  }
  getServiceTypeLabel(): string {
    const type = sessionStorage.getItem('selectedServiceType');
    const map: Record<string, string> = {
      eStamp: 'Bulk E-Stamp',
      eSign: 'Bulk E-Sign',
      both: 'Bulk E-Stamp & E-Sign',
    };
    return type ? (map[type] ?? type) : 'Bulk E-Stamp';
  }
  ngOnDestroy(): void {
    localStorage.removeItem('paymentStatus');
  }
}
